import React, { useState } from 'react';

export default function MonthCalendarSelector({ selectedDates, onToggleDate }) {
    // Simple 1-month calendar view for the current month
    // In a real app, this would have prev/next month controls
    const today = new Date();
    const [currentDate, setCurrentDate] = useState(new Date(today.getFullYear(), today.getMonth(), 1));

    const getDaysInMonth = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    const getFirstDayOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1).getDay();

    const daysInMonth = getDaysInMonth(currentDate);
    const firstDay = getFirstDayOfMonth(currentDate);

    // Days of week header (S, M, T, W, T, F, S)
    const dayNames = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

    const renderGrid = () => {
        const grid = [];
        let dayCounter = 1;

        // 6 rows to cover all month layouts
        for (let i = 0; i < 6; i++) {
            const row = [];
            for (let j = 0; j < 7; j++) {
                if (i === 0 && j < firstDay) {
                    row.push(<td key={`empty-${j}`} style={styles.cell}></td>);
                } else if (dayCounter > daysInMonth) {
                    row.push(<td key={`empty-end-${j}`} style={styles.cell}></td>);
                } else {
                    const dateObj = new Date(currentDate.getFullYear(), currentDate.getMonth(), dayCounter);
                    // use local date string as key YYYY-MM-DD
                    const dateStr = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;
                    const isSelected = selectedDates.includes(dateStr);
                    const isPast = dateObj < new Date(today.setHours(0,0,0,0));

                    row.push(
                        <td key={dateStr} style={styles.cell}>
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (!isPast) onToggleDate(dateStr);
                                }}
                                disabled={isPast}
                                style={{
                                    ...styles.dateBtn,
                                    backgroundColor: isSelected ? '#0056b3' : 'transparent',
                                    color: isSelected ? 'white' : (isPast ? '#d1d5db' : '#374151'),
                                    cursor: isPast ? 'not-allowed' : 'pointer',
                                    fontWeight: isSelected ? 'bold' : 'normal',
                                    border: isSelected ? '1px solid #0056b3' : '1px solid transparent'
                                }}
                            >
                                {dayCounter}
                            </button>
                        </td>
                    );
                    dayCounter++;
                }
            }
            grid.push(<tr key={`row-${i}`}>{row}</tr>);
            if (dayCounter > daysInMonth) break;
        }
        return grid;
    };

    const nextMonth = (e) => {
        e.preventDefault();
        setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
    };

    const prevMonth = (e) => {
        e.preventDefault();
        setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
    };

    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <div style={{ fontWeight: '600', color: '#374151', fontSize: '14px' }}>
                    {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
                </div>
                <div style={styles.nav}>
                    <button onClick={prevMonth} style={styles.navBtn}>&lt;</button>
                    <button onClick={nextMonth} style={styles.navBtn}>&gt;</button>
                </div>
            </div>
            
            <table style={styles.table}>
                <thead>
                    <tr>
                        {dayNames.map((day, i) => (
                            <th key={i} style={styles.th}>{day}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {renderGrid()}
                </tbody>
            </table>
        </div>
    );
}

const styles = {
    container: {
        width: '100%',
        fontFamily: 'sans-serif',
        marginTop: '10px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '16px',
        padding: '0 8px'
    },
    nav: {
        display: 'flex',
        gap: '8px'
    },
    navBtn: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontSize: '16px',
        color: '#6b7280',
        padding: '4px'
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse'
    },
    th: {
        fontSize: '12px',
        color: '#6b7280',
        fontWeight: '500',
        paddingBottom: '12px',
        textAlign: 'center'
    },
    cell: {
        textAlign: 'center',
        padding: '4px'
    },
    dateBtn: {
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        transition: 'all 0.2s'
    }
};
